function cacheBust(url) {
  const now = new Date();
  return `${url}?${now.getTime()}`;
}

const FetchMyAccountService = {
  getCustomerInfo: rest => rest({
    method: 'GET',
    path: cacheBust('/api/v1/customers/current')
  }),
  sendChange: (rest, entity) => rest({
    method: 'POST',
    path: '/api/v1/account/requestChange',
    entity
  })
};

export default FetchMyAccountService;



/** WEBPACK FOOTER **
 ** ./src/services/FetchMyAccountService.js
 **/